import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useContactStore = defineStore('contact', () => {
  // State
  const projectName = ref(null)
  const firstName = ref(null)
  const lastName = ref(null)
  const email = ref(null)
  const phone = ref(null)
  const productInterest = ref(null)
  const agree = ref(false)
  const tosAgree = ref(false)

  // Getters
  const contactInfo = computed(() => ({
    projectName: projectName.value,
    firstName: firstName.value,
    lastName: lastName.value,
    email: email.value,
    phone: phone.value,
    productInterest: productInterest.value,
    agree: agree.value,
    tosAgree: tosAgree.value,
  }))

  // Actions
  function resetState() {
    projectName.value = null
    firstName.value = null
    lastName.value = null
    email.value = null
    phone.value = null
    productInterest.value = null
    agree.value = false
    tosAgree.value = false
  }

  function saveContactInfo({ data }) {
    projectName.value = data.projectName
    firstName.value = data.firstName
    lastName.value = data.lastName
    email.value = data.email
    phone.value = data.phone
    productInterest.value = data.productInterest
    agree.value = data.agree
    tosAgree.value = data.tosAgree
  }

  return {
    // State
    projectName,
    firstName,
    lastName,
    email,
    phone,
    productInterest,
    agree,
    tosAgree,

    // Getters
    contactInfo,

    // Actions
    resetState,
    saveContactInfo
  }
})
